import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import NavLink from '../nav_link';

const styles = () => ({
    topic: {
        paddingLeft: '32px',
        maxHeight: '40px',
        paddingRight: '1.0rem',
    },
});

class JetListJobs extends React.Component {
    render() {
        const { classes, onActive } = this.props;
        return (
            <>
                <Collapse component="div" in={this.props.isOpen} timeout="auto">
                    <List disablePadding>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={onActive}
                            to="/jet/jobs/jet-dashboard"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Using the Dashboard" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={onActive}
                            to="/jet/jobs/working-with-jobs"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Working With Jobs" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={onActive}
                            to="/jet/jobs/job-trigger-types"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Job Trigger Types" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={onActive}
                            to="/jet/jobs/post-transfer-actions"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Post-Transfer Actions" />
                            </ListItem>
                        </NavLink>
                        <NavLink onClick={this.props.handleDrawerToggle} to="/jet/jobs/partner-jobs">
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Creating Partner Jobs" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={onActive}
                            to="/jet/jobs/viewing-job-details"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary=" Viewing Job Details" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={onActive}
                            to="/jet/jobs/installer-logs"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Jet Logs" />
                            </ListItem>
                        </NavLink>

                        <NavLink onClick={this.props.handleDrawerToggle} to="/jet/troubleshooting-jobs">
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Troubleshooting" />
                            </ListItem>
                        </NavLink>
                    </List>
                </Collapse>
            </>
        );
    }
}

JetListJobs.propTypes = {
    classes: PropTypes.object.isRequired,
    isOpen: PropTypes.object,
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default withStyles(styles)(JetListJobs);
